import { currencyString } from '@sales-center/common'
export const currencyValueFormatter = (value: any): string =>
  (!!value && typeof value === 'string') || typeof value === 'number'
    ? `$${currencyString(value)}`
    : ''
